module.exports = __webpack_public_path__ + "img/controlEngineering.a375e183.jpg";